module.exports = __webpack_public_path__ + "static/img/p1-t1.69eac6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-t1.png
// module id = vZtW
// module chunks = 0